import { render, staticRenderFns } from "./NotesModalMobile.vue?vue&type=template&id=47784dd2&scoped=true&"
import script from "./NotesModalMobile.vue?vue&type=script&lang=js&"
export * from "./NotesModalMobile.vue?vue&type=script&lang=js&"
import style0 from "./NotesModalMobile.vue?vue&type=style&index=0&id=47784dd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47784dd2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47784dd2')) {
      api.createRecord('47784dd2', component.options)
    } else {
      api.reload('47784dd2', component.options)
    }
    module.hot.accept("./NotesModalMobile.vue?vue&type=template&id=47784dd2&scoped=true&", function () {
      api.rerender('47784dd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/NotesModalMobile.vue"
export default component.exports